import queryString from 'query-string';
import { get, post, del } from './apiUtils';

const defaultUrl = '/ProductPhraseTRs/';

export default {
  getProductPhraseTRList: query => (query ? get(`${defaultUrl}?${queryString.stringify(query)}`) : get(defaultUrl)),
  saveProductPhraseTR: data => post(defaultUrl, data),
};
